import { useIntl } from 'react-intl';

import { SelectInput } from 'Views/Components/New/SelectInput';
import { BookingWizardData } from '../../BookingWizardData/BaseBookingWizardData';
import { isVehicleBookingWizardData, VehicleBookingWizardData } from '../../BookingWizardData/VehicleBookingWizardData';
import { useBookingWizardDataStore } from '../../BookingWizardDataStore';
import { WizardErrors } from '../../BookingWizardTypes';
import { VehicleTabActionCreators, wizardDataVehicleTabReducer } from './Reducers/vehicleTabReducer';
import { useVehicleTabContext } from './VehicleTabContext';

export function VehicleModelInput() {
	const { cargoTypes } = useVehicleTabContext();
	const intl = useIntl();
	const { wizardData, oldWizardData, setWizardData, innerWizardErrors, setInnerWizardErrors } =
		useBookingWizardDataStore();

	if (!isVehicleBookingWizardData(wizardData.innerWizardData)) {
		return <></>;
	}

	const typedErrors = innerWizardErrors as WizardErrors<VehicleBookingWizardData>;
	const { cargoModel, cargoMake } = wizardData.innerWizardData;

	const options = cargoTypes
		.filter(x => x.cargoMake === cargoMake)
		.sort((a, b) => a.cargoModel.localeCompare(b.cargoModel))
		.map(x => ({ value: x.cargoModel, label: x.cargoModel }));

	return (
		<SelectInput
			className="vehicle-model"
			label={intl.formatMessage({
				id: 'vehicle-tab__vehicle-model__label',
				defaultMessage: 'Model',
			})}
			placeholder={intl.formatMessage({
				id: 'vehicle-tab__vehicle-model__placeholder',
				defaultMessage: 'Select model',
			})}
			options={options}
			value={cargoModel ? { value: cargoModel, label: cargoModel } : null}
			required
			isSearchable
			error={typedErrors?.cargoModel}
			onChange={(option: any) => {
				const selectedModel = option?.value ?? '';
				const staged = new BookingWizardData({ ...wizardData });
				if (isVehicleBookingWizardData(staged.innerWizardData)) {
					staged.innerWizardData.cargoModel = selectedModel;
				}
				const newData = wizardDataVehicleTabReducer(
					staged,
					VehicleTabActionCreators.changeModel({ cargoTypes, oldWizardData }),
				);
				if (newData) {
					setWizardData(newData);
				}

				const newErrors = { ...typedErrors };
				delete newErrors.cargoModel;
				delete newErrors.vehicleLengthId;
				setInnerWizardErrors(newErrors);
			}}
		/>
	);
}
